export enum TripsViewMode {
  TRIPS = 'TRIPS',
  POSITIONS = 'POSITIONS',
}
